<template lang="pug">
b-container(class="justify-content-center")
  .ticket.text-center
    .title Experience how making the most of online data can create value for your organization
</template>

<script>
import Message from '@/components/Shared/Message.vue'

export default {
  name: 'Finisher',
  components: {
    Message
  },
  props: {
  }
}



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

$color-title: #364149;
$color-subtitle: #767F86;
.ticket {
  background-color: #36C2CF;
  color: #FFFFFF;
  height: 310px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .title {
    font-style: normal;
    font-weight: bold;
    font-size: 40px;
    line-height: 45px;
  }
  .action {
    margin: 47px 0;
    background: #FFFFFF;
    color: #36C2CF;
    border: none;
    border-radius: 100px;
    padding: 1em 2em;
    font-style: normal;
    font-weight: bold;
    line-height: 18px;
    display: flex;
    align-items: flex-end;
    text-align: center;
    text-transform: uppercase;
    outline: none !important;
    box-shadow: none !important;
  }
}
@media only screen and (min-width: 991px) {
  .ticket {
    margin-top: 3em;
    max-width: 1170px;
    padding: 200px;
    .title {
      max-width: 850px;
      font-size: 40px;
      line-height: 45px;
    }
  }
}
@media only screen and (max-width: 991px) {
  .ticket {
    margin-top: 83px;
    padding: 10% 5% 0;
    .title {
      width: 100%;
      font-size: 25px;
      line-height: 30px;
    }
  }
}


</style>
